import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_JOB_LINK_DETAILS_QUERY = gql`
  query GetJobLinkDetails($cloudId: String!) {
    getJob(cloudId: $cloudId) {
      cloudId
      name
      WfDeletedOnUTC
      clientId
    }
  }
` as import('../../__generated__/ts-gql/GetJobLinkDetails').type;

export type GetJobLinkDetailsQueryVariables = OperationVariables<
  typeof GET_JOB_LINK_DETAILS_QUERY
>;
export type GetJobLinkDetailsQueryResult = OperationData<
  typeof GET_JOB_LINK_DETAILS_QUERY
>;
export type GetJobLinkDetailsType = GetJobLinkDetailsQueryResult['getJob'];

export type GetJobLinkDetailsResult = NonNullable<
  ReturnType<typeof processData>
>;

// type picked = Pick<Job, 'cloudId' | 'name' | 'WfDeletedOnUTC' | 'clientId'>;
// type omitted = Omit<picked, 'WfDeletedOnUTC'>;

// export interface GetJobLinkDetailsResult extends omitted {
//   WfDeletedOnUTC: Date | null;
// }

export const useGetJobLinkDetails = (
  options: QueryHookOptions<
    GetJobLinkDetailsQueryResult,
    GetJobLinkDetailsQueryVariables
  >
) => {
  const variables = options.variables as GetJobLinkDetailsQueryVariables;

  const res = useQuery(GET_JOB_LINK_DETAILS_QUERY, {
    context: { service: 'core' },
    variables,
    ...options,
  });

  return React.useMemo(() => ({ ...res, data: processData(res.data) }), [res]);
};

export function processData(data: GetJobLinkDetailsQueryResult | undefined) {
  const raw = data?.getJob;
  const result = raw && {
    ...raw,
    WfDeletedOnUTC: raw.WfDeletedOnUTC && new Date(raw.WfDeletedOnUTC),
  };
  return result;
}
